import { render } from "./Error500.vue?vue&type=template&id=e84870e0"
import script from "./Error500.vue?vue&type=script&lang=js"
export * from "./Error500.vue?vue&type=script&lang=js"

import exportComponent from "/home/leandro/trabalho-timo/kuhlenbier-web-frontend-partner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__